import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

import { SasButtonComponent } from '../sas-button/sas-button.component';

@Component({
    selector: 'sas-related-item',
    standalone: true,
    imports: [SasButtonComponent],
    templateUrl: './sas-related-item.component.html',
    styleUrl: './sas-related-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'sas-related-item',
        '[class.sas-related-item--empty]': 'empty()',
        '[class.sas-related-item--focus-visible]': 'refFocusVisible()',
        '(click)': 'onCardClick()',
        '(focusin)': 'onFocusIn($event)',
        '(focusout)': 'refFocusVisible.set(false)'
    }
})
export class SasRelatedItemComponent {
    readonly kind        = input.required<string>();
    readonly ref         = input.required<string>();
    readonly empty       = input<boolean>(false);
    readonly actionLabel = input<string>('Open ↗');
    readonly ariaLabel   = input<string | undefined>(undefined);
    readonly refClickable = input<boolean>(false);
    readonly meta         = input<string>('');
    readonly dismissible  = input<boolean>(false);
    readonly dismissLabel = input<string>('DISMISS');

    readonly sasAction  = output<void>();
    readonly sasDismiss = output<Event>();

    protected readonly refFocusVisible = signal(false);

    // Inner sas-buttons stop propagation, so ref and X clicks never reach here.
    onCardClick(): void {
        if (!this.empty()) this.sasAction.emit();
    }

    // Card ring only for keyboard focus on the ref, not for the X or mouse clicks.
    onFocusIn(event: FocusEvent): void {
        const target = event.target as HTMLElement;
        this.refFocusVisible.set(!!target.closest('.sas-related-item__ref') && target.matches(':focus-visible'));
    }
}
